/**
 * Get the rectangle aspect ratio (ratio of width to height).
 * @param {object} rectangle
 * @returns {number}
 */
const getAspectRatio = rectangle => {
  return rectangle.width / rectangle.height;
};

export default getAspectRatio;
